import { observer } from "mobx-react-lite";
import { useIsClient } from "usehooks-ts";

import { Sidebar } from "@/components/sidebar";
import { CrispChatButton } from "@/components/sidebar/CrispChat";
import { HintsButton } from "@/components/sidebar/hints/HintsButton";
import { HintsPanel } from "@/components/sidebar/hints/HintsContent";
import { LinksButton } from "@/components/sidebar/links-button/LinksButton";
import { MathThemeSwitcher } from "@/components/sidebar/math-theme-switcher/MathThemeSwitcher";
import { ThemeSwitcher } from "@/components/sidebar/theme-switcher/ThemeSwitcher";
import * as Skeleton from "@/components/skeleton/Skeleton";
import { useStore } from "@/store";
import { twMerge } from "@/utils/twMerge";
import { useFeatureFlag } from "@/utils/useFeatureFlag";

type Props = {
  className?: string;
};

export const BottomMenu = observer(function BottomMenu({ className }: Props) {
  const { view } = useStore();
  const isClient = useIsClient();
  const hintsPanelEnabled = useFeatureFlag("tips-box");

  if (!isClient) {
    return (
      <Sidebar.Group className={twMerge("mt-auto", className)}>
        <Skeleton.Root>
          <Sidebar.GroupSection className="mt-0 p-0">
            <Skeleton.Block
              className={twMerge("h-[38px]", view.isLeftSidebarCollapsed && "h-[176px]")}
            />
          </Sidebar.GroupSection>
        </Skeleton.Root>
      </Sidebar.Group>
    );
  }

  return (
    <Sidebar.Group className={twMerge("mt-auto", className)}>
      <div className="flex flex-1 flex-col min-w-0">
        {hintsPanelEnabled && view.leftSidebarState === "full" && <HintsPanel />}
        <div
          className={twMerge(
            "flex flex-1 flex-row min-h-[38px] gap-2",
            view.isLeftSidebarCollapsed && "flex-col",
          )}
        >
          <ThemeSwitcher />
          <MathThemeSwitcher />
          <CrispChatButton />
          {hintsPanelEnabled && view.leftSidebarState === "full" && <HintsButton />}
          <span className="ml-auto">
            <LinksButton />
          </span>
        </div>
      </div>
    </Sidebar.Group>
  );
});
